module.exports = __webpack_public_path__ + "static/media/get_help_image.f25b6d10.png";